import { Header } from "@/components/Header";
import { PremiumFooter } from "@/components/landing/PremiumFooter";
import { FileText } from "lucide-react";

const Terms = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />

      <section className="pt-24 pb-16">
        <div className="container mx-auto px-6 max-w-4xl">
          <div className="text-center mb-12">
            <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-6">
              <FileText className="w-8 h-8 text-primary" />
            </div>
            <h1 className="text-4xl font-bold text-foreground mb-4 font-display">
              Conditions Générales d'Utilisation
            </h1>
            <p className="text-muted-foreground">Dernière mise à jour : 3 décembre 2024</p>
          </div>

          <div className="prose prose-invert max-w-none">
            <div className="bg-card border border-border rounded-2xl p-8 space-y-8">
              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">1. Objet</h2>
                <p className="text-muted-foreground">
                  Les présentes Conditions Générales d'Utilisation (CGU) régissent l'utilisation du service Floop, 
                  une plateforme de génération et de retouche d'images par intelligence artificielle.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">2. Acceptation des conditions</h2>
                <p className="text-muted-foreground">
                  En accédant ou en utilisant Floop, vous acceptez d'être lié par les présentes CGU. 
                  Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser notre service.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">3. Description du service</h2>
                <p className="text-muted-foreground mb-4">
                  Floop est un service de génération d'images basé sur notre modèle d'intelligence artificielle. 
                  Le service comprend :
                </p>
                <ul className="list-disc list-inside text-muted-foreground space-y-2">
                  <li>Génération d'images à partir de descriptions textuelles (Floop Basic)</li>
                  <li>Retouche et transformation d'images avancées (Floop Pro)</li>
                  <li>Stockage temporaire des images générées</li>
                  <li>Historique des générations</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">4. Inscription et compte</h2>
                <p className="text-muted-foreground">
                  Pour utiliser Floop, vous devez créer un compte en fournissant des informations exactes et complètes. 
                  Vous êtes responsable de la confidentialité de vos identifiants et de toutes les activités sur votre compte.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">5. Système de crédits</h2>
                <p className="text-muted-foreground mb-4">L'utilisation de Floop fonctionne sur un système de crédits :</p>
                <ul className="list-disc list-inside text-muted-foreground space-y-2">
                  <li>Les crédits sont consommés lors de chaque génération d'image</li>
                  <li>Les crédits achetés sont non remboursables sauf disposition légale contraire</li>
                  <li>Les crédits non utilisés restent valables pendant 12 mois</li>
                  <li>Le coût en crédits varie selon le modèle et la résolution utilisés</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">6. Propriété intellectuelle</h2>
                <p className="text-muted-foreground">
                  Les images générées via Floop vous appartiennent. Vous pouvez les utiliser à des fins personnelles et commerciales 
                  sous réserve du respect des lois applicables et des droits des tiers. Floop conserve les droits sur sa technologie, 
                  son interface et sa marque.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">7. Utilisation acceptable</h2>
                <p className="text-muted-foreground mb-4">Il est interdit d'utiliser Floop pour :</p>
                <ul className="list-disc list-inside text-muted-foreground space-y-2">
                  <li>Générer du contenu illégal, diffamatoire ou portant atteinte aux droits d'autrui</li>
                  <li>Créer des deepfakes malveillants ou du contenu trompeur</li>
                  <li>Générer du contenu à caractère sexuel impliquant des mineurs</li>
                  <li>Contourner les mesures de sécurité du service</li>
                  <li>Revendre ou redistribuer l'accès au service</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">8. Limitation de responsabilité</h2>
                <p className="text-muted-foreground">
                  Floop est fourni "tel quel". Nous ne garantissons pas l'exactitude, la qualité ou l'adéquation 
                  des images générées à vos besoins spécifiques. Notre responsabilité est limitée au montant 
                  des crédits achetés au cours des 12 derniers mois.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">9. Modification des CGU</h2>
                <p className="text-muted-foreground">
                  Nous nous réservons le droit de modifier ces CGU à tout moment. Les modifications seront notifiées 
                  par email ou via l'interface du service. La poursuite de l'utilisation après notification vaut acceptation.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">10. Droit applicable</h2>
                <p className="text-muted-foreground">
                  Les présentes CGU sont régies par le droit français. Tout litige sera soumis aux tribunaux compétents de Paris.
                </p>
              </section>
            </div>
          </div>
        </div>
      </section>

      <PremiumFooter />
    </div>
  );
};

export default Terms;
